import ManagerDetail from "./ManagerDetail";
export default ManagerDetail